import { observer } from 'mobx-react';
import GenericSortFilter from '../../../GenericSortFilter';
import GroupParticipantsStore from '../GroupParticipantsStore/Store';

interface Props {
  groupParticipantsStore: GroupParticipantsStore;
}

function FiltersWithOptions({ groupParticipantsStore }: Props) {
  switch (groupParticipantsStore.optionsStore.state.kind) {
    case 'error':
    case 'loading':
    case 'waiting':
      return <></>;
    case 'ready':
      const { payload } = groupParticipantsStore.optionsStore.state.resource;
      const width = 'w-48';
      return (
        <>
          <div className="mr-4">
            <GenericSortFilter
              labelText="Last Login"
              options={payload.loginActivities}
              width={width}
              parameters={groupParticipantsStore.searchParameters}
              updatingParameters={groupParticipantsStore.updatingSearchParameters}
              sortFilterKey={'last_sign_in_at'}
            />
          </div>
          <div className="mr-4">
            <GenericSortFilter
              labelText="Collection Membership"
              options={payload.learningCollections}
              width={width}
              parameters={groupParticipantsStore.searchParameters}
              updatingParameters={groupParticipantsStore.updatingSearchParameters}
              sortFilterKey={'learning_collection'}
            />
          </div>
        </>
      );
  }
}

export default observer(FiltersWithOptions);
